import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';
import { FormInputUrl } from '@/_containers';

import type { MagazineFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<MagazineFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Magazine (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="website"
        render={({ field }) => (
          <FormInputUrl
            formItemClassName="col-span-12 sm:col-span-6"
            label="Website"
            {...field}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
